export default __webpack_public_path__ + "static/media/seat.37875763.svg";